import {
  createUnifiedTheme,
  createBaseThemeOptions,
  palettes,
  genPageTheme,
  shapes,
} from '@backstage/theme';

const LINUXELL_BLUE = '#22488D';
const LINUXELL_BLUE_DARK = '#0F1F45';
const LINUXELL_ACCENT = '#FF9F1C';

export const linuxellLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: { main: LINUXELL_BLUE },
      secondary: { main: LINUXELL_ACCENT },
      navigation: {
        ...palettes.light.navigation,
        background: LINUXELL_BLUE_DARK,
        indicator: LINUXELL_ACCENT,
        color: '#FFFFFF',
        selectedColor: '#FFFFFF',
      },
    },
  }),
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: [LINUXELL_BLUE, LINUXELL_BLUE_DARK], shape: shapes.wave }),
    documentation: genPageTheme({ colors: [LINUXELL_BLUE, LINUXELL_ACCENT], shape: shapes.wave2 }),
    tool: genPageTheme({ colors: [LINUXELL_BLUE_DARK, LINUXELL_BLUE], shape: shapes.round }),
    service: genPageTheme({ colors: [LINUXELL_BLUE, LINUXELL_BLUE_DARK], shape: shapes.wave }),
    website: genPageTheme({ colors: [LINUXELL_BLUE, LINUXELL_ACCENT], shape: shapes.wave }),
    library: genPageTheme({ colors: [LINUXELL_BLUE_DARK, LINUXELL_ACCENT], shape: shapes.round }),
    other: genPageTheme({ colors: [LINUXELL_BLUE, LINUXELL_BLUE_DARK], shape: shapes.wave }),
    app: genPageTheme({ colors: [LINUXELL_BLUE, LINUXELL_BLUE_DARK], shape: shapes.wave }),
    apis: genPageTheme({ colors: [LINUXELL_BLUE, LINUXELL_ACCENT], shape: shapes.wave }),
  },
});

export const linuxellDarkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: { main: LINUXELL_ACCENT },
      secondary: { main: LINUXELL_BLUE },
      navigation: {
        ...palettes.dark.navigation,
        background: LINUXELL_BLUE_DARK,
        indicator: LINUXELL_ACCENT,
        color: '#FFFFFF',
        selectedColor: '#FFFFFF',
      },
    },
  }),
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: [LINUXELL_BLUE_DARK, LINUXELL_BLUE], shape: shapes.wave }),
    documentation: genPageTheme({ colors: [LINUXELL_BLUE_DARK, LINUXELL_ACCENT], shape: shapes.wave2 }),
    tool: genPageTheme({ colors: [LINUXELL_BLUE_DARK, LINUXELL_BLUE], shape: shapes.round }),
    service: genPageTheme({ colors: [LINUXELL_BLUE_DARK, LINUXELL_BLUE], shape: shapes.wave }),
    website: genPageTheme({ colors: [LINUXELL_BLUE_DARK, LINUXELL_ACCENT], shape: shapes.wave }),
    library: genPageTheme({ colors: [LINUXELL_BLUE_DARK, LINUXELL_ACCENT], shape: shapes.round }),
    other: genPageTheme({ colors: [LINUXELL_BLUE_DARK, LINUXELL_BLUE], shape: shapes.wave }),
    app: genPageTheme({ colors: [LINUXELL_BLUE_DARK, LINUXELL_BLUE], shape: shapes.wave }),
    apis: genPageTheme({ colors: [LINUXELL_BLUE_DARK, LINUXELL_ACCENT], shape: shapes.wave }),
  },
});
